var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{presented: _vm.question.presented_to_user, skipped: _vm.question.skipped},domProps:{"innerHTML":_vm._s(_vm.questionTextValue)}})}
var staticRenderFns = []

export { render, staticRenderFns }